import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { useTheme } from '../../theme';

interface PageHeaderProps {
  title: string;
  actions?: React.ReactNode;
}

export default function PageHeader({ title, actions }: PageHeaderProps) {
  const { theme } = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3,
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          color: theme.text.primary,
        }}
      >
        {title}
      </Typography>
      {actions && <Stack direction="row" spacing={2}>{actions}</Stack>}
    </Box>
  );
}
